import React from "react";
import { Helmet } from "react-helmet";

function Home_Seo() {
  return (
    <div>
      <Helmet>
        <title>
          Money Transfer to Nigeria with Ifepay – Fast, Secure & Zero Fee
          Remittances
        </title>
        <meta
          name="description"
          content="Transfer money to Nigeria with Ifepay – a fast, secure, and affordable way to send remittances. Enjoy zero transfer fees, great exchange rates, and trusted service for seamless money transfers to Nigeria."
        />
        <meta
          property="og:title"
          content="Money Transfer to Nigeria with Ifepay – Fast, Secure & Zero Fee Remittances"
        />
        <meta
          property="og:description"
          content="Transfer money to Nigeria with Ifepay – a fast, secure, and affordable way to send remittances. Enjoy zero transfer fees, great exchange rates, and trusted service for seamless money transfers to Nigeria."
        />
        <meta
          property="og:image"
          content="https://ifepay.co.uk/assets/images/logo.png"
        />{" "}
        {/* Replace with actual image URL */}
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ifepay.co.uk/" />
      </Helmet>
    </div>
  );
}

export default Home_Seo;
